var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlagEn = function SvgIconFlagEn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "32px",
    viewBox: "0 0 48 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon/icon_flag_en")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/icon_flag_en",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon_flag_en",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,31 C1.9,31 1,30.1 1,29 L1,3 C1,1.9 1.9,1 3,1 L45,1 C46.1,1 47,1.9 47,3 L47,29 C47,30.1 46.1,31 45,31 L3,31 Z",
    id: "Shape",
    fill: "#3B5998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,3 C47,1.9 46.1,1 45,1 L42.2,1 L24.3,12.6 L6.5,1 L3,1 C1.9,1 1,1.9 1,3 L1,4.6 L18.8,16.2 L1,27.8 L1,29 C1,30.1 1.9,31 3,31 L7.1,31 L24.3,19.8 L41.5,31 L45,31 C46.1,31 47,30.1 47,29 L47,27.4 L29.8,16.2 L47,5 L47,3 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6,30.5 L24.3,19.2 L7,30.5 L3,30.5 C2.2,30.5 1.5,29.8 1.5,29 L1.5,28.1 L19.7,16.2 L1.5,4.3 L1.5,3 C1.5,2.2 2.2,1.5 3,1.5 L6.3,1.5 L24.3,13.2 L42.3,1.5 L45,1.5 C45.8,1.5 46.5,2.2 46.5,3 L46.5,4.7 L28.9,16.2 L46.5,27.7 L46.5,29 C46.5,29.8 45.8,30.5 45,30.5 L41.6,30.5 Z",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4,30.5 L24.3,17.4 L4.2,30.5 L3,30.5 C2.5,30.5 2,30.2 1.7,29.8 L22.5,16.3 L1.6,2.6 C1.8,2 2.3,1.5 3,1.5 L3.6,1.5 L24.3,15 L45.1,1.5 C45.9,1.6 46.5,2.2 46.5,2.9 L26.1,16.2 L46.4,29.4 C46.2,30 45.6,30.5 45,30.5 L44.4,30.5 Z",
    id: "Shape",
    fill: "#AA1A1A"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "19.5 32 19.5 20.5 0 20.5 0 11.5 19.5 11.5 19.5 0 28.5 0 28.5 11.5 48 11.5 48 20.5 28.5 20.5 28.5 32"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#AA1A1A",
    x: 1,
    y: 13,
    width: 46,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#AA1A1A",
    x: 21,
    y: 1,
    width: 6,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,0 L3,0 C1.3,0 0,1.3 0,3 L0,29 C0,30.7 1.3,32 3,32 L45,32 C46.7,32 48,30.7 48,29 L48,3 C48,1.3 46.7,0 45,0 Z M47,29 C47,30.1 46.1,31 45,31 L3,31 C1.9,31 1,30.1 1,29 L1,3 C1,1.9 1.9,1 3,1 L45,1 C46.1,1 47,1.9 47,3 L47,29 Z",
    id: "Shape",
    fill: "#999999"
  })))));
};
export default SvgIconFlagEn;